import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AiNarrationGraphBlock } from '../../models/ai-assistant.models';

@Component({
  selector: 'app-response-narration-graph',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './response-narration-graph.component.html',
  styleUrl: './response-narration-graph.component.css',
})
export class ResponseNarrationGraphComponent {
  @Input({ required: true }) block!: AiNarrationGraphBlock;

  barWidth(value: number, maxValue: number): string {
    return `${Math.min(100, Math.round((value / maxValue) * 100))}%`;
  }
}
